'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileName = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FileName, _Component);

  function FileName(props) {
    (0, _classCallCheck3.default)(this, FileName);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FileName.__proto__ || (0, _getPrototypeOf2.default)(FileName)).call(this, props));

    _this.state = {
      filename: props.uploader.methods.getName(props.id)
    };

    _this._interceptSetName();
    return _this;
  }

  (0, _createClass3.default)(FileName, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.filename !== this.state.filename;
    }
  }, {
    key: '_interceptSetName',
    value: function _interceptSetName() {
      var _this2 = this;

      var oldSetName = this.props.uploader.methods.setName;

      this.props.uploader.methods.setName = function (id, newName) {
        oldSetName.call(_this2.props.uploader.methods, id, newName);

        if (id === _this2.props.id) {
          _this2.setState({
            filename: newName
          });
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var filename = this.state.filename;
      var _props = this.props,
          hideName = _props.hideName,
          className = _props.className;

      var displayName = filename;
      if (hideName && filename) {
        displayName = filename.split('.').pop();
      }

      return _react2.default.createElement(
        'span',
        { className: className, title: displayName },
        displayName
      );
    }
  }]);
  return FileName;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  hideName: _propTypes2.default.bool,
  id: _propTypes2.default.number.isRequired,
  uploader: _propTypes2.default.object.isRequired
}, _temp);
exports.default = FileName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/FileName.js
// module id = 1995
// module chunks = 1